import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var pointsDetailsRes;
export const pointsDetailsTodo = createAsyncThunk('pointsDetails', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/get_user_points',
            data: {
                "user_id": val,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return pointsDetailsRes = res.data
    } catch (error) {
        return pointsDetailsRes = error.response.data
    }
})


const pointsDetailsSlice = createSlice({
    name: 'pointsDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(pointsDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('pointsDetails', state.data)
            }
        });
        builder.addCase(pointsDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default pointsDetailsSlice.reducer; 